import TaskManagerEditDto from './TaskManagerEditDto';
import DataSplitTaskFieldEditDto from './DataSplitTaskFieldEditDto';

export class DataSplitTaskEditDto extends TaskManagerEditDto {
    constructor() {
        super();

        /** @type {number} */
        this.measurement = null;

        /** @type {number} */
        this.dataset = null;

        /** @type {DataSplitTaskFieldEditDto[]} */
        this.keyFields = null;

        /** @type {DataSplitTaskFieldEditDto[]} */
        this.valueFields = null;
    }

    /**
     * @typedef {Object} _DataSplitTaskEditDtoProps
     * @property {number} measurement
     * @property {number} dataset
     * @property {DataSplitTaskFieldEditDto[]} keyFields
     * @property {DataSplitTaskFieldEditDto[]} valueFields
     *
     * @typedef {import("./TaskManagerEditDto").TaskManagerEditDtoProps & _DataSplitTaskEditDtoProps} DataSplitTaskEditDtoProps
     */
    /**
     *
     * @param {DataSplitTaskEditDtoProps} props
     * @returns {DataSplitTaskEditDto}
     */
    setup(props) {
        super.setup(props);

        this.measurement = props.measurement;
        this.dataset = props.dataset;
        this.keyFields = props.keyFields !== null ? props.keyFields.map(d => new DataSplitTaskFieldEditDto().setup(d)) : [];
        this.valueFields = props.valueFields !== null ? props.valueFields.map(d => new DataSplitTaskFieldEditDto().setup(d)) : [];

        return this;
    }
}

export default DataSplitTaskEditDto;
